// A light-weight abusesa-js Event replacement
// for cases where a full class is not necessary.
// Does not support "every()", "count()" and "value()"
export default class FakeEvent {
    constructor(item) {
        this._item = item || {};
    }

    values(key, mapFilter) {
        let results = [],
            values = this._item[key],
            hasFunc = !!(mapFilter && typeof mapFilter === "function"),
            hasMap = !hasFunc && !!(mapFilter && mapFilter.map),
            hasFilter = !hasFunc && !!(mapFilter && mapFilter.filter);

        if (values === void 0) {
            return results;
        }

        if (!Array.isArray(values)) {
            values = [values];
        }

        values.forEach(function(value) {
            if (hasFunc) {
                value = mapFilter(value);
            } else if (hasMap) {
                value = mapFilter.map(value);
            }

            if (hasFilter) {
                if (mapFilter.filter(value)) {
                    results.push(value);
                }
            } else if (hasFunc || hasMap) {
                // (value === value) is equal to !isNaN(value)
                if ((value !== null) && (value !== void 0) && (value === value)) {
                    results.push(value);
                }
            } else {
                results.push(value);
            }
        });

        return results;
    }

    some(func, context) {
        for (let key in this._item) {
            if (func.call(context, this._item[key], key, this)) {
                return true;
            }
        }
        return false;
        //return Object.keys(this._item).some(function(key) {
        //    return func.call(context, this._item[key], key, this);
        //}, this);
    }

    forEach(func, context) {
        for (let key of Object.keys(this._item)) {
            func.call(context, this._item[key], key, this);
        }
    }
}



// WEBPACK FOOTER //
// ./src/kpi/lib/FakeEvent.js